import { createRoot } from 'react-dom/client';
import './i18n';
import './i18nAddonP3';
import './i18nAddonP2A2';
import App from './App.tsx';
import './index.css';
import { registerGlobalErrorHandlers } from '@/lib/error-handling';
import { initSentry, registerSentryConsentListener } from '@/lib/sentry';

// OPT451-FE: FR/NL/PL/IT/ES resource bundles (i18nAddonFR_NL / PL_IT_ES / P3_FR_NL /
// P3_PL_IT_ES) are loaded on demand from public/locales/<lng>/translation.json via
// i18next-http-backend in src/i18n.ts (partialBundledLanguages). The DE+EN
// extensions (i18nAddonP3, i18nAddonP2A2) stay imported synchronously because they
// only add ~6 k LOC of city-SEO keys and are bundled inline for fast first paint.

initSentry();
registerSentryConsentListener();
registerGlobalErrorHandlers();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element with id "root" not found');
}

const root = createRoot(container);

root.render(<App />);
